import { useQuery } from "@tanstack/react-query";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { useCopilotApi } from "../backend/index.ts";

// For now just checks if they have an API key set.
// Unlike `useCopilotApi().getOpenAIApiKey()` (used by the setting page), this doesn't validate the key.
export const useCopilotStatus = () => {
  const formatMessage = useFormatMessage(formatStrings);

  const api = useCopilotApi();

  return useQuery({
    queryKey: ["copilot", "status"],
    queryFn: async () => {
      const status = await api.getStatus();

      const enabled = status.hasApiKey;

      // return a reason description from the status API instead?
      const reason = status.hasApiKey ? null : formatMessage("noApiKeyTooltip");

      return { enabled, status, reason };
    },
  });
};

const formatStrings = {
  noApiKeyTooltip: {
    en: "API key is not set",
  },
} satisfies FormatMessages;
